<template>
  <BaseCustomizeMetal componentCode="P" useGodNameVerticalText />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalP",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  img {
    // 因葫蘆的形狀是垂直的，以高 100% 為標準撐開
    width: auto !important;
    height: 100%;
  }
  .metal-text {
    top: 63px;
    left: 170px;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 29px;
      left: 119px;
    }
    @include table {
      transform: scale(0.7);
      top: 10px;
      left: 95px;
    }
    @include phone {
      transform: scale(0.64);
      top: 0px;
      left: 80px;
    }
  }
  .templeName {
    height: 28px;
    width: 158px;
    .textContainer {
      width: 158px;
    }
  }
  .godName {
    width: 49px;
    height: 151px;
    writing-mode: vertical-lr;
    writing-mode: vertical-rl;
    .textContainer {
      width: 49px;
      height: 151px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .gift {
    width: 79px;
    height: 33px;
    .textContainer {
      width: 79px;
    }
  }
  .respect {
    margin: 5px auto;
  }
}
</style>
